import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import moment from 'moment';
import { 
  REQUEST_DETAIL_LIST,
  REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT,
  REQUEST_DETAIL_ADD,
  REQUEST_DETAIL_DETAIL,
  REQUEST_DETAIL_UPDATE,
  REQUEST_DETAIL_UPLOAD_SET
} from '../actions';
import {
  RequestDetailListSuccess,
  RequestDetailListError,
  RequestDetailSearchDeliveryOrderLineLotSuccess,
  RequestDetailSearchDeliveryOrderLineLotError,
  RequestDetailAddSuccess,
  RequestDetailAddError,
  RequestDetailDetailSuccess,
  RequestDetailDetailError,
  RequestDetailUpdateSuccess,
  RequestDetailUpdateError,
  RequestDetailUploadSetSuccess,
  RequestDetailUploadSetError
} from '../actions';
 
export function* watchRequestDetailList() {
  yield takeEvery(REQUEST_DETAIL_LIST, onRequestDetailList);
}

export function* watchRequestDetailSearchDeliveryOrderLineLot() {
  yield takeEvery(REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT, onRequestDetailSearchDeliveryOrderLineLot);
}

export function* watchRequestDetailAdd() {
  yield takeEvery(REQUEST_DETAIL_ADD, onRequestDetailAdd);
}

export function* watchRequestDetailDetail() {
  yield takeEvery(REQUEST_DETAIL_DETAIL, onRequestDetailDetail);
}

export function* watchRequestDetailUpdate() {
  yield takeEvery(REQUEST_DETAIL_UPDATE, onRequestDetailUpdate);
}

export function* watchRequestDetailUpload() {
  yield takeEvery(REQUEST_DETAIL_UPLOAD_SET, onRequestDetailUpload);
}

const onRequestDetailListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onRequestDetailUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onRequestDetailSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestDetailAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onRequestDetailDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onRequestDetailUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/request_detail/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_request_details/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_request_details/'});
      });
    });
  });
};


function* onRequestDetailList(data) {
  try {
    const response = yield call(onRequestDetailListAsync, data.payload);
    yield put(RequestDetailListSuccess(response.data));
  } catch (error) {
    yield put(RequestDetailListError(error));
  }
}

function* onRequestDetailSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onRequestDetailSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(RequestDetailSearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(RequestDetailSearchDeliveryOrderLineLotError(error));
  }
}

function* onRequestDetailAdd(data) {
  try {
      const response = yield call(onRequestDetailAddAsync, data);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestDetailAddSuccess(response.data));
  } catch (error) {
      yield put(RequestDetailAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onRequestDetailDetail(data) {
  try {
    const response = yield call(onRequestDetailDetailAsync, data.payload);
    yield put(RequestDetailDetailSuccess(response.data.data));
  } catch (error) {
    yield put(RequestDetailDetailError(error));
  }
}

function* onRequestDetailUpdate(data) {
  try {
      const response = yield call(onRequestDetailUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestDetailUpdateSuccess(response.data));
  } catch (error) {
      yield put(RequestDetailUpdateError(error));
  }
}

function* onRequestDetailUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onRequestDetailUploadAsync, file);
    if(response.message ==='success'){
      yield put(RequestDetailUploadSetSuccess(response));
    }
    else{
      yield put(RequestDetailUploadSetError(response));
    }
  } catch (error) {
    yield put(RequestDetailUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchRequestDetailList),
    fork(watchRequestDetailSearchDeliveryOrderLineLot),
    fork(watchRequestDetailAdd),
    fork(watchRequestDetailDetail),
    fork(watchRequestDetailUpdate),
    fork(watchRequestDetailUpload),
  ]);
} 